module.exports = __webpack_public_path__ + "img/moneyBack7.8c860abf.png";